import { Link, useNavigate, useParams } from "react-router-dom"
import MainLayout from "../../components/layouts/MainLayout"
import { useEffect, useState } from "react"
import { commandeApi } from "../../api/commandeApi"
import { Alert, Spin, Collapse, Button, message, Image, Tag } from "antd"
import { PlusCircleOutlined, LeftCircleOutlined, DownloadOutlined } from '@ant-design/icons';
import { CommandeApi } from "../../api/commandeApi"
import Swal from "sweetalert2"
import { Auth } from "../../utils/Auth"
import Money from "../../components/Money"
const { Panel } = Collapse;

const DetailsCommandeView = () => {
    const {id} = useParams()
    const [commande, setCommande] = useState(null)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null);
    const [comment, setComment] = useState('');
    const abortController = new AbortController()
    const navigate = useNavigate()
    
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
      };
    
      const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
          const res = await CommandeApi.getCommandeDetails(`${id}`,abortController.signal);
          setCommande(res.data); 
        } catch (err) {
          setError("Impossible de charger les détails de la commande.");
        } finally {
          setLoading(false);
        }
      };
    useEffect(() => {
        fetchData();
    }, [id]);     

    const handleComment = async (commande) => {
        const payload = {
            comment: comment,            
          }
        try{
        const res = await CommandeApi.comment(commande.id,JSON.stringify(payload),abortController.signal)
        
        if (!res.success) {
            return Swal.fire({
                title:'Impossible d\'enregistrer',
                text:res.message,
                // timer:3000
            })
        }
        message.success('Commentaire enregistré avec succès');

        } catch (error) {
                  message.error('Une erreur est survenue lors de l\'ajout de la commande');
                  const messages = await error.messages ?? error.message;
        
                  if(messages instanceof Array)
                      return Swal.fire({
                        title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                        text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                        icon:"error",
                      }).then((result) => {
                        Auth.removeSessionToken()
                        return navigate(`/login`)			
                      });
                } finally {
                  setLoading(false);
                }
    }
   

    return <MainLayout>
    <div className="container mx-auto p-6">
        <div className="flex justify-between">
            <h1 className="text-3xl font-semibold mb-6">Détails de la commande {commande?.order_number}</h1>
            <Link to={`/commandes`}><LeftCircleOutlined/> Retour  </Link>
        </div>

      {loading && <Spin size="large" />}
      {error && <Alert message={error} type="error" />}
      {!loading && !error && commande && (
        <div className="bg-white p-6 rounded-lg shadow-md">
          {/* Information personnelle */}
          <Collapse defaultActiveKey={['1']} expandIconPosition="start">
            <Panel header="Informations vendeur" key="1" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Nom vendeur:</strong> {commande?.annonce?.user?.name?.toUpperCase()+' '+commande?.annonce?.user?.lastname?.toUpperCase() ?? '' }</p>
                {/* <p><strong>Email :</strong> {commande.email || "Non fourni"}</p> */}
                <p><strong>Numéro de téléphone :</strong> {commande?.annonce?.user?.contact || "Non fourni"}</p>
                <p><strong>Date de la commande :</strong> {formatDate(commande?.order_date)}</p>
                
              </div>
            </Panel>
          </Collapse>

          {/* Information sur les contacts */}
          <Collapse defaultActiveKey={['2']} expandIconPosition="start" className="mt-4">
            <Panel header="Informations de client" key="2" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Client :</strong> {commande?.customer_name || "Non fournie"}</p>
                <p><strong>Contact :</strong> {commande?.customer_number || "Non fournie"}</p>
              </div>
            </Panel>
          </Collapse>

          {/* Information sur la société */}
          <Collapse defaultActiveKey={['3']} expandIconPosition="start" className="mt-4">
            <Panel header="Commande" key="3" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <p><strong>Article :</strong> {commande?.annonce?.title || "Non fourni"}</p>
                <p><strong>Prix de l'article :</strong> {commande?.virtual_amount ? <Money amount={commande.virtual_amount} /> : "Non fournie"}</p>
                <p><strong>Montant de la commande :</strong> {commande?.total_amount ? <Money amount={commande.total_amount} /> : "Non fourni"}</p>
                <p><strong>Commission :</strong> {commande?.commission ? <Money amount={commande.commission} /> : "Non fourni"}</p>
              </div>
            </Panel>
          </Collapse>

          {/* Facture associée */}
          <Collapse defaultActiveKey={['4']} expandIconPosition="start" className="mt-4">
            <Panel header="Facture associée" key="4" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                {commande?.facture ? (
                  <>
                    <p><strong>N° facture :</strong> {commande?.facture.numero_facture}</p>
                    <p><strong>Montant TTC :</strong> <Money amount={commande.facture.montant_total_ttc} /></p>
                    <p><strong>Montant Commission :</strong> <Money amount={commande.facture.montant_total_commissione} /></p>
                    <p><strong>Date de dépôt :</strong> {formatDate(commande?.facture.date_emission)}</p>
                    <p><strong>Statut :</strong> {commande?.facture.statut ? <Tag>{commande?.facture.statut}</Tag> : "Non renseigné"}</p>
                    {commande?.facture.image_facture && (
                      <Image src={commande?.facture.image_facture} alt="Facture" width={150} />
                    )}
                    <div className="space-x-4">
                      {commande?.facture.image_facture && (
                        <a href={commande?.facture.image_facture} download target="_blank" rel="noreferrer">
                          <DownloadOutlined /> Télécharger
                        </a>
                      )}
                      <Link to={`/factures/${commande?.facture.id}/details`}>Voir la fiche complète</Link>
                    </div>
                  </>
                ) : (
                  <p>Aucune facture n'a encore été transmise pour cette commande.</p>
                )}
              </div>
            </Panel>
          </Collapse>

          {/* Presentation/description*/}
          <Collapse defaultActiveKey={['5']} expandIconPosition="start" className="mt-4">
            <Panel header="Commentaire" key="5" extra={<PlusCircleOutlined />}>
              <div className="space-y-4">
                <textarea value={comment} className="w-full px-4 py-2 border border-gray-300 rounded-md" placeholder="Votre commentaire..." name="comment" onChange={(e) => setComment(e.target.value)}></textarea>
                </div>
            </Panel>
          </Collapse>

          <div className="mt-2">
              {
               
                <Button onClick={()=> handleComment(commande)} className="btn bg-red-700 text-white rounded-md">Laisser un commentaire</Button>
              }
              
          </div>
          
        </div>

        
      )}
    </div>
  </MainLayout>

}
export default DetailsCommandeView